module.exports = __webpack_public_path__ + "media/images/flags/1x1/aia-85ca92ead86e845f232814f0a8a84090.svg";